import { APP_CONSTS } from 'core/constants/app-consts';

export const convertChosenLabel = (chosenLabel: string = '') => {
    if (chosenLabel === 'Custom Range') {
        return null;
    }
    if (!chosenLabel.includes('|')) {
        return chosenLabel;
    }
    const [selectedKey] = Object.entries(APP_CONSTS.date.keys).find(([key, value]) => {
        if (chosenLabel.includes(value)) {
            return key;
        }
        return null;
    }) || [''];

    return (
        APP_CONSTS.date.labels[selectedKey as keyof typeof APP_CONSTS.date.labels] ?? chosenLabel
    );
};
